module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-visit-form-view",
    attrs: {
      "width": "850px",
      "title": "拜访详情",
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.myVisible = $event
      },
      "close": _vm.handerClose
    }
  }, [(_vm.myDetail) ? _c('el-row', {
    staticClass: "toolbar",
    attrs: {
      "gutter": 24
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "110px",
      "label-position": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访客户："
    }
  }, [_vm._v(" " + _vm._s(_vm.$route.query.companyName || _vm.myDetail.companyName) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户经理："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.adminUserName) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户成功经理："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.successfulManagerName || '-') + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.agencyManagerName || '-') + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访日期："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.payVisitDate ? _vm.myDetail.payVisitDate.split(" ")[0] : '-'))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.contactUser) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系方式："
    }
  }, [_vm._v(" " + _vm._s(_vm.myDetail.contactPhone) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "职位："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.position || '-'))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访方式："
    }
  }, [_c('span', {
    staticClass: "myTag-fill",
    class: _vm.myDetail.payVisitStatus == 1 ? 'pruple' : (_vm.myDetail.payVisitStatus == 2 ? 'primary' : 'warning')
  }, [_vm._v("\n                " + _vm._s(_vm.myDetail.payVisitStatus == 1 ? "电话沟通" : (_vm.myDetail.payVisitStatus == 2 ? '客户现场' : '视频会议')) + "\n              ")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户地址："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.addressInfo))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访详情："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.payVisitInfo || '-'))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现场照片："
    }
  }, [(_vm.myDetail.picList.length > 0) ? _c('PictureList', {
    attrs: {
      "pictureList": _vm.myDetail.picList
    }
  }) : _c('span', [_vm._v("-")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核状态："
    }
  }, [_c('span', {
    staticClass: "myTag",
    class: [_vm.myDetail.auditStatus == 1 ? 'warning' : 'primary']
  }, [_vm._v("\n                " + _vm._s(_vm.myDetail.auditStatus == 1 ? "待审核" : '已审核') + "\n              ")])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', [_c('span', {
    staticClass: "dividerSpan"
  }, [_vm._v("评论（" + _vm._s(_vm.commentList.length) + "）")])]), _vm._v(" "), _c('div', {
    staticClass: "commentBox"
  }, [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.commentList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "avatar"
    }), _vm._v(" "), _c('div', {
      staticClass: "itemInfo"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.username || '-'))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.intime || '-'))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.note || '-'))]), _vm._v(" "), _c('div', {
      staticClass: "actionBox"
    }, [(item.userid != _vm.userInfo.id) ? _c('span', {
      staticClass: "dnnfont iconcomment-dots",
      on: {
        "click": function($event) {
          return _vm.reply(item)
        }
      }
    }, [_vm._v(" 回复")]) : _vm._e(), _vm._v(" "), (item.userid === _vm.userInfo.id) ? _c('span', {
      staticClass: "dnnfont icondelete",
      on: {
        "click": function($event) {
          return _vm.deleteComment(item)
        }
      }
    }, [_vm._v(" 删除")]) : _vm._e()])])])
  }), 0), _vm._v(" "), (_vm.userInfo.type == 1 && !_vm.isReply) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "3",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.commentNote),
      callback: function($$v) {
        _vm.commentNote = $$v
      },
      expression: "commentNote"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isReply) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "3",
      "placeholder": '回复 ' + _vm.replyObj
    },
    model: {
      value: (_vm.replyNote),
      callback: function($$v) {
        _vm.replyNote = $$v
      },
      expression: "replyNote"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btnBox"
  }, [(_vm.userInfo.type == 1 && !_vm.isReply) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.postLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.postComment.apply(null, arguments)
      }
    }
  }, [_vm._v("发表评论")]) : _vm._e(), _vm._v(" "), (_vm.isReply) ? _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeReply.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isReply) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.postLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.replyComment.apply(null, arguments)
      }
    }
  }, [_vm._v("回复")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.myDetail && _vm.userInfo.type == 1 && _vm.myDetail.auditStatus == 1) ? _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmit(_vm.myDetail)
      }
    }
  }, [_vm._v("审核通过")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a4ff2d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/companys/TrackManage/ModalFormView.vue
// module id = 1761
// module chunks = 9